<ng-container *transloco="let t; read: 'ime.common.property-mappings'">
  <div class="modal-header" ngxModalDraggable>
    <h4 class="modal-title pull-left me-auto">{{title}}</h4>
    <div>
      <button type="button" class="btn btn-sm btn-outline-primary" [ngClass]="{'active': showPropertyLocalizations}" *ngIf="localizationEnabled"
              (click)="showPropertyLocalizations = !showPropertyLocalizations">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#flag"></svg>
        {{t('Localization')}}
      </button>
      <button type="button" class="btn btn-sm btn-outline-primary ms-2" (click)="change()" *ngIf="!readonly">{{t('Change')}}</button>
      <button type="button" class="btn-close pull-right ms-2" aria-label="Close" (click)="close()">
      </button>
    </div>
  </div>
  <div class="modal-body">
    <form>
      <ime-spec-lines-edit [context]="context"
                           [showLocalization]="showPropertyLocalizations"
                           [showLocalizationButton]="localizationEnabled"
                           [wasValidated$]="wasValidated$"
                           [readonly]="readonly"
                           (changed)="isChanged = true"></ime-spec-lines-edit>
    </form>
  </div>
</ng-container>
